import { render, staticRenderFns } from "./FormStoreGiftListCategoryComponent.vue?vue&type=template&id=405c5202&scoped=true"
import script from "./FormStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"
export * from "./FormStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./FormStoreGiftListCategoryComponent.vue?vue&type=style&index=0&id=405c5202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c5202",
  null
  
)

export default component.exports